import { B as T, j as e, V as _, I as le, T as ce } from "./Spinner-dTAYYnIx.js";
import de, { useState as W, useEffect as q, useRef as pe } from "react";
import { styled as l, keyframes as he, css as p } from "styled-components";
import { C as xe, R as B } from "./Row-qde4lVc-.js";
import { c as t, i as me, a as y, B as u, p as E, o as H, T as I, j as w, e as v, d as $e, m as P } from "./style-8UHgYe1v.js";
import { f as fe, e as a, P as ue, F as V, b as je } from "./index-QRkynDgW.js";
import { u as be } from "./useTransitionState-9D4Z4_FK.js";
import { u as G } from "./useMediaQuery-iK133h0J.js";
import { C as ge } from "./Container-acMbkeg4.js";
import { S as U } from "./Section-cF107_Su.js";
import { O as ye, T as R } from "./Transition-zqoQyz_U.js";
import { R as X } from "./Resizer-WG5IpuTF.js";
import { T as we } from "./TileSkeleton-GTAZ6jJH.js";
import { A as z } from "./Accordion-JV3htPLx.js";
import { D as ve } from "./Drawer-BXoKtCFh.js";
import { T as Q } from "./typography.styled-aDVGHct9.js";
import { F as ke } from "./icon-filters-vC2aY28V.js";
import { C as Ae } from "./icon-close-SnhI1pSy.js";
const Ce = l(T)`
  padding-left: 0;
`, Be = l(U).attrs({
  $display: "flex",
  $alignItems: "center",
  $justifyContent: "space-between"
})`
  ${fe};

  background-color: ${t.white};
`, J = l.div`
  width: 100%;
`, Te = he`
  100% {
    background-color: #e1e1e1;
  }
  15% {
    background-color: ${t.grey};
  }
  0% {
    background-color: #e1e1e1;
  }
`, K = p`
  animation-name: ${Te};
  animation-duration: 2.15s;
  animation-fill-mode: forwards;
  animation-timing-function: ${me};
  animation-iteration-count: infinite;
`, N = l.div`
  width: ${({ width: r }) => r || "100%"};
  height: 100%;
  height: 24px;
  margin: ${a.spacer3} ${a.spacer4} ${a.spacer3} ${a.spacer0};
  ${y(
  u.xl,
  p`
      margin: ${a.spacer2} ${a.spacer3} ${a.spacer2} ${a.spacer0};
    `
)}
  position: relative;
  overflow: hidden;
  ${E(p`
    forced-color-adjust: preserve-parent-color;
  `)}
  ${K}
`, Y = ({ width: r }) => /* @__PURE__ */ e.jsx(J, { children: /* @__PURE__ */ e.jsx(N, { width: r }) }), Z = ({
  toggleFilter: r,
  isLoading: c,
  selectedFilterCount: s,
  t: i,
  dataBadgeQa: h,
  isOpen: $
}) => /* @__PURE__ */ e.jsx(Be, { $position: "bottom", "data-qa": "filter-bar", children: c ? /* @__PURE__ */ e.jsx(Y, { width: "100px" }) : /* @__PURE__ */ e.jsx(
  Ce,
  {
    "aria-expanded": $,
    badgeValue: s,
    badgeAriaLabel: i.filterBarBadgeAriaLabel,
    variant: "icon",
    onClick: r,
    icon: {
      icon: ke,
      size: "sm",
      position: "right"
    },
    dataBadgeQa: h,
    children: i.filterBarButtonLabel
  }
) }), Le = l.button`
  ${H(I.bodyS)}
  ${w("border-color, text-decoration, background-color", v.shortest)}

  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 40px;
  padding: ${a.spacer1} ${a.spacer3};
  text-decoration: underline 1px ${t.transparent};
  color: ${t.white};
  background-color: ${t.greyAlpha80};
  border: 1px solid ${t.transparent};

  svg {
    ${w("color", v.shortest)}
    color: ${t.white};
  }

  &:hover,
  &:active {
    background-color: ${t.greyAlpha60};
    svg {
      color: ${t.white};
    }
  }

  &:focus {
    outline: none;
    box-shadow: ${t.white} inset 0 0 0 1px;
  }

  ${E(p`
    svg {
      color: currentcolor;
    }

    &:hover {
      color: WindowText;
      border: 1px solid currentcolor;
      ${$e("background-color", "dominantAlpha80")}

      svg {
        color: currentcolor;
      }
    }
  `)}
`, Oe = ({ children: r, dataQa: c, accessibilityLabel: s, ...i }) => /* @__PURE__ */ e.jsxs(Le, { ...i, "data-qa": c ?? "filter-tag", children: [
  r,
  /* @__PURE__ */ e.jsx(_, { as: "span", children: s }),
  /* @__PURE__ */ e.jsx(le, { $ml: "spacer2", icon: Ae, size: 16 })
] }), ee = "333px", re = "404px", Se = l.div`
  ${w("opacity", v.shorter)};

  opacity: ${({ $isOpen: r }) => r ? 1 : 0};
  padding-right: ${a.spacer4};
  width: ${ee};
  overflow: hidden;

  ${y(
  u.xl,
  p`
      padding-right: ${a.spacer5};
    `
)}

  ${y(
  u.xxl,
  p`
      padding-right: ${a.spacer6};
      width: ${re};
    `
)}
`, De = l.aside`
  ${w("width", v.short)};

  display: block;
  flex-shrink: 0;
  background-color: ${t.white};
  padding: 0;
  width: 0;
  overflow: hidden;

  ${({ $isOpen: r }) => r && p`
      width: ${ee};

      ${y(
  u.xxl,
  p`
          width: ${re};
        `
)}
    `}
`, Fe = l(ue).attrs({ $pb: "spacer4" })`
  display: flex;
  flex-wrap: wrap;
  gap: ${a.spacer2};
`, ie = ({
  drawerProps: r,
  accordionProps: c,
  t: s,
  isLoading: i,
  onClose: h,
  onAsideTransitionEnd: $,
  isAsidePending: j,
  asideExpanded: o,
  isDrawerOpen: f,
  tags: d,
  onClearAllClick: O
}) => {
  const S = G(P(u.lg)), [k, x] = W(!1);
  q(() => {
    let n;
    return i ? n = setTimeout(() => {
      clearTimeout(n), x(i);
    }, 500) : x(i), () => clearTimeout(n);
  }, [i]);
  const g = (n) => {
    typeof $ == "function" && $(n);
  }, b = (n) => n && /* @__PURE__ */ e.jsx(_, { children: /* @__PURE__ */ e.jsx(Q, { as: "h2", children: n }) });
  return S ? !j && !o ? null : /* @__PURE__ */ e.jsx(
    De,
    {
      "aria-expanded": o,
      onTransitionEnd: g,
      $isOpen: o,
      "aria-label": s.filterTrayAriaLabel,
      children: /* @__PURE__ */ e.jsxs(Se, { $isOpen: o, children: [
        b(s.filterTrayTitleLabel),
        /* @__PURE__ */ e.jsx(z, { ...c, isLoading: k })
      ] })
    }
  ) : /* @__PURE__ */ e.jsx(
    ve,
    {
      ...r,
      isOpen: f,
      onClose: h,
      t: s,
      headerContent: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        b(s.filterTrayTitleLabel),
        /* @__PURE__ */ e.jsx(Q, { $textAlign: "center", $variant: I.bodySMedium, children: s.filterTrayTitleLabel })
      ] }),
      theme: "light",
      footerContent: /* @__PURE__ */ e.jsxs(V, { $columnGap: a.spacer2, children: [
        /* @__PURE__ */ e.jsx(T, { onClick: O, variant: "secondary", fullWidth: !0, children: s.filterTrayClearAllLabel }),
        /* @__PURE__ */ e.jsx(T, { onClick: h, variant: "primary", fullWidth: !0, children: s.filterTrayApplyLabel })
      ] }),
      children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(X, { children: !!(d != null && d.length) && /* @__PURE__ */ e.jsx(Fe, { children: d == null ? void 0 : d.map((n) => n.children) }) }),
        /* @__PURE__ */ e.jsx(z, { ...c, isLoading: k })
      ] })
    }
  );
}, L = l(xe).attrs((r) => ({ $mb: { xs: "spacer7", lg: "spacer8" }, ...r }))`
  ${w("max-width, flex", v.shorter)}
`, Re = l(L).attrs((r) => ({ $mb: { xs: "spacer7", lg: "spacer8" }, ...r }))`
  display: none;
  ${y(
  u.lg,
  p`
      display: flex;
      gap: ${a.spacer2};
      flex-wrap: wrap;
    `
)}
`, We = l(T)`
  ${H(I.bodySMedium)}
`, _e = ({ expanded: r }) => {
  const c = de.useRef(
    Array(8).fill(0).map((s, i) => i)
  );
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: c.current.map((s) => /* @__PURE__ */ e.jsx(
    L,
    {
      $col: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: r ? 6 : 4,
        xl: r ? 4 : 3
      },
      children: /* @__PURE__ */ e.jsx(we, {})
    },
    s
  )) });
}, Ie = ({
  filterBarProps: r,
  drawerProps: c,
  accordionProps: s,
  componentStatus: i,
  items: h,
  isInitiallyOpen: $,
  t: j,
  onFilterTrayToggle: o,
  tags: f,
  onClearAllClick: d,
  error: O,
  loadMore: S,
  theme: k = "light"
}) => {
  const x = G(P(u.lg)), g = pe(!0), [b, D] = W(!1), [A, n] = W(!1), [se, C, ae] = be(A, ["width"]), ne = (m) => {
    x ? n(!1) : D(!1), o == null || o(m, !1);
  }, oe = (m) => {
    const F = x ? !A : !b;
    x ? n(F) : D(F), o == null || o(m, F);
  };
  q(() => {
    i === "ready" && g.current && x && (g.current = !1, n(!!$));
  }, [$, i, g, x]);
  const M = ["loading", "initial"].includes(i), te = ["loadingMore", "ready"].includes(i);
  return /* @__PURE__ */ e.jsx(ce, { theme: k, children: /* @__PURE__ */ e.jsx(U, { "data-qa": "story-archive", children: /* @__PURE__ */ e.jsxs(ge, { $fluid: !0, children: [
    /* @__PURE__ */ e.jsx(
      Z,
      {
        ...r,
        isLoading: i === "initial",
        toggleFilter: oe,
        t: j,
        dataBadgeQa: "archive-button-badge",
        isOpen: A || b
      }
    ),
    /* @__PURE__ */ e.jsxs(V, { children: [
      /* @__PURE__ */ e.jsx(
        ie,
        {
          t: j,
          drawerProps: c,
          accordionProps: s,
          isDrawerOpen: b,
          onClose: ne,
          isLoading: M,
          onClearAllClick: d,
          onAsideTransitionEnd: ae,
          asideExpanded: C,
          isAsidePending: se,
          tags: f
        }
      ),
      /* @__PURE__ */ e.jsxs(je, { $flexGrow: "1", children: [
        /* @__PURE__ */ e.jsx(X, { children: i !== "initial" && !!(f != null && f.length) && /* @__PURE__ */ e.jsx(B, { children: /* @__PURE__ */ e.jsxs(Re, { $col: 12, children: [
          f.map((m) => m.children),
          /* @__PURE__ */ e.jsxs(
            We,
            {
              $ml: "spacer2",
              variant: "inline",
              onClick: d,
              dataQa: "archive-clear-all-button",
              children: [
                j.clearAllLabel,
                /* @__PURE__ */ e.jsx(_, { as: "span", children: j.clearAllFiltersLabel })
              ]
            }
          )
        ] }) }) }),
        /* @__PURE__ */ e.jsxs(ye, { children: [
          /* @__PURE__ */ e.jsxs(R, { visible: te, children: [
            /* @__PURE__ */ e.jsx(B, { children: h == null ? void 0 : h.map((m) => /* @__PURE__ */ e.jsx(
              L,
              {
                $col: {
                  xs: 12,
                  sm: 6,
                  md: 4,
                  lg: C ? 6 : 4,
                  xl: C ? 4 : 3
                },
                children: m.children
              },
              m.id
            )) }),
            S
          ] }),
          /* @__PURE__ */ e.jsx(R, { visible: M, children: /* @__PURE__ */ e.jsx(B, { children: /* @__PURE__ */ e.jsx(_e, { expanded: C }) }) }),
          /* @__PURE__ */ e.jsx(R, { visible: i === "error", children: /* @__PURE__ */ e.jsx(B, { children: /* @__PURE__ */ e.jsx(L, { $col: 12, children: O }) }) })
        ] })
      ] })
    ] })
  ] }) }) });
}, ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnimationBody: K,
  ContentSkeleton: N,
  FilterBar: Z,
  FilterBarSkeleton: Y,
  FilterTag: Oe,
  FilterTray: ie,
  StoriesArchive: Ie,
  Wrapper: J
}, Symbol.toStringTag, { value: "Module" }));
export {
  K as A,
  N as C,
  Oe as F,
  Ie as S,
  J as W,
  ie as a,
  Z as b,
  Y as c,
  ir as i
};
